import React from 'react';

import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/productdetail/productSkuNumber.scss';

interface Props {
  productId: string;
  showSku: boolean;
}

const ProductSkuNumber = ({ productId, showSku }: Props) => {
  const { testId } = useMartyContext();
  return (
    <div className={css.container}>
      {showSku && (
        <div data-test-id={testId('sku')}>
          SKU <span itemProp="sku">{productId}</span>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary('ProductSkuNumber', ProductSkuNumber);
